import { render, staticRenderFns } from "./ProjectRouteSelector.vue?vue&type=template&id=c25ca336"
import script from "./ProjectRouteSelector.vue?vue&type=script&lang=js"
export * from "./ProjectRouteSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports